// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY,
    authDomain: process.env.VUE_APP_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_DATABASEURL,
    projectId: process.env.VUE_APP_PROJECTID,
    storageBucket: process.env.VUE_APP_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
    appId: process.env.VUE_APP_APPID
};

export const api = process.env.VUE_APP_API;

export const maxRounds = 8;
export const skipFinalDiceRoll = false;

export const referenceWidth = 1067;
export const referenceHeight = 832;

export const api_Game = api + "/Game";
export const api_getGameId = api_Game + "/Create";

// https://docs.google.com/spreadsheets/d/1lxDUWf2qzmKzMgM-2HOZYmMkfG0t6FjnEjR-IJoAAfI/edit?gid=0#gid=0
export const scriptURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQUOg3NaEIClGURkC3Jh1i6BsnRor9yivD-1gbzwfuv_sztdZhX23xohG12hu4SwOseWxxeEU5JE4kR/pub?gid=0&single=true&output=csv";

// https://docs.google.com/spreadsheets/d/1HysadsoZr9QUjzc9vk2CH3X8SI4ihMIUA03NIoPUCSA/edit?gid=0#gid=0
export const damageURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGBBeWRjtmm75zOhQc03KN-xtWk51YWLxdnNyde6pcPeqsVtu66gYSctI-vQnhuX14Nj6ErNALpmps/pub?gid=0&single=true&output=csv";

// https://docs.google.com/spreadsheets/d/15fvExQHthDC4ttP_2xMK8W3mzRUfADWx-3kHLDT6PEs/edit?gid=0#gid=0
export const valuesURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQDpzkqTx4cDU7ZT4PfMYA3r65olYrPxPldrClAS_g2Wii4NU1hxN-Me34UHzd4qyeVzzK2UDKJ7LXv/pub?gid=0&single=true&output=csv";

// https://docs.google.com/spreadsheets/d/1--HECyRd4GztiMiEjM_OtpRBz4AJpTHxEo-aSjKq8OM/edit?gid=0#gid=0
export const upgradesURL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJjHxM6BDo7o1OkaHt5w947AClrnGUscWOm6MmAbxDmvPfx0M7kiibz8g_Wns4u3dq0KYJKcRZUs8s/pub?gid=0&single=true&output=csv";
